import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var feedbackListRes;
export const feedbackListTodo = createAsyncThunk('feedbackList', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'master/view_feedback_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return feedbackListRes = res.data
    } catch (error) {
        return feedbackListRes = error.response.data
    }
})


const feedbackListSlice = createSlice({
    name: 'feedbackList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(feedbackListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('feedbackList', state.data)
            }
        });
        builder.addCase(feedbackListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default feedbackListSlice.reducer; 